export var EStatus;

(function (EStatus) {
  EStatus["NORMAL"] = "normal";
  EStatus["DISABLED"] = "disabled";
  EStatus["DANGER"] = "danger";
})(EStatus || (EStatus = {}));

export var EStatusTheme;

(function (EStatusTheme) {
  EStatusTheme["NORMAL"] = "branding";
  EStatusTheme["DISABLED"] = "disabled";
  EStatusTheme["DANGER"] = "warning";
})(EStatusTheme || (EStatusTheme = {}));